import type { InputHTMLAttributes } from 'react'

import { Input } from '@/components/forms/input'

function SearchIcon() {
  return (
    <svg aria-hidden className="size-4" fill="none" viewBox="0 0 16 16">
      <path
        d="M7.25 12.5a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Zm3.8-1.45 2.45 2.45"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export type SearchInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix' | 'type'>

export function SearchInput(props: SearchInputProps) {
  return <Input prefix={<SearchIcon />} type="search" {...props} />
}
